import React, { createContext, useState, useEffect } from 'react';
import i18n, { matchWithSupportedLangs } from '../i18n.js';
import firebase from '../Firebase.js';

export const AuthContext = createContext();

export default (props) => {

  const [state, setState] = useState({
    checkingAuth: true,
    authChanged: false,
    authUser: null,
  });

  const updateAuthUser = (objToMerge) => setState(state => {
    return { ...state, authUser: { ...state.authUser, ...objToMerge } };
  });

  const isAuthAdmin = () => state.authUser && state.authUser.emailVerified && state.authUser.hasRoleAdmin;
  const isAuthTrainer = () => state.authUser && state.authUser.emailVerified && state.authUser.acceptedByAdmin;
  const isAuthTrainerOrAdmin = () => isAuthAdmin() || isAuthTrainer();

  useEffect(() => {
    const handleUserAuthChange = () => {
      return firebase.auth().onAuthStateChanged(async (user) => {
	setState(state => { return { ...state,  authChanged: true }; });
	if (!user) {
	  setState({ authChanged: false, checkingAuth: false, authUser: null });
	  return;
	}
	try {
	  const plainUser = { photoURL: user.photoURL, email: user.email, emailVerified: user.emailVerified };
	  if (!user.emailVerified) {
	    setState({ authChanged: false, checkingAuth: false, authUser: plainUser });
	    return;
	  }
	  const trainer = await firebase.firestore().collection('trainers').doc(user.email).get();
	  if (!trainer.data() || !trainer.data().hasRegistered) {
	    const lang = matchWithSupportedLangs();
	    const trainerData =
		  (await firebase.functions()
		   .httpsCallable('registerAsTrainer')({name: user.displayName || '', lang})).data;
	    i18n.changeLanguage(lang);
	    await firebase.auth().currentUser.getIdToken(true);
	    setState({ authChanged: false, checkingAuth: false, authUser: { ...plainUser, ...trainerData }});
	    return;
	  }
	  if (!trainer.data().acceptedByAdmin) {
	    setState({ authChanged: false, checkingAuth: false, authUser: { ...plainUser, ...trainer.data() }});
	  } else {
		  const profile = await firebase.firestore().collection('trainers')
			  .doc(user.email).collection('profile').doc('details').get();
		  setState({ authChanged: false, checkingAuth: false, authUser: { ...plainUser, ...trainer.data(), ...profile.data() } });
		  const webAppExamDetails = await firebase.firestore().collection('webAppExams').doc(user.email).get();
		  if (webAppExamDetails.data()) {
			  setState({ authChanged: false, checkingAuth: false, authUser: { ...plainUser, ...trainer.data(), ...profile.data(), ...webAppExamDetails.data() } });
		  }
		  if (i18n.language !== profile.data().uiLang) {
			  i18n.changeLanguage(profile.data().uiLang);
		  }
	  }
	}
	catch (error) {
	  setState({ authChanged: false, checkingAuth: false, authUser: null });
	  firebase.auth().signOut();
	  console.log('errors getting trainer data and auth claims ', error);
	}
      });
    };
    handleUserAuthChange();
  }, []);

  return (
    <AuthContext.Provider value={{ ...state,
				   updateAuthUser,
				   isAuthAdmin,
				   isAuthTrainerOrAdmin }}>
      { props.children }
    </AuthContext.Provider>
  );
}
